module.exports = __webpack_public_path__ + "img/Feature.385e8cd9.png";